export const VIEWER_Z_INDEX = {
  root: 1,
  layer: 1,
  link: 10,
  ctaButton: 18,
  pageListButton: 2,
  /* NOTE: 영상 임베드 - dot/messageBox보다 아래에 위치해야 한다 */
  embed: 15,
  dotButton: 102,
  messageBoxButton: 102,
  mobileDrawerDimmer: 104,
  mobileDrawer: 105,
  mobileCloseButton: 106,
  /*
   * NOTE: 첫 방문 도움말 오버레이
   * 페이지 위에 얹히는 요소(link/embed/ctaButton/freeBadge/dot/모바일 버튼)를 모두 덮고,
   * 툴바·문의양식 모달·모바일 드로어(104 이상)보다는 아래에 있어야 한다.
   * ctaFormDimmer와는 값이 같지만 DOM 순서상 dimmer가 뒤에 있어 dimmer가 위로 그려진다.
   */
  previewLayer: 103,
  /*
   * NOTE: V2 가로 맞춤 힌트 칩
   * 페이지 위에 얹히는 요소(link/embed/ctaButton/freeBadge)보다는 위,
   * 첫 방문 도움말 오버레이·문의양식 딤/모달·툴바(103 이상)보다는 아래에 있어야 한다.
   * dotButton/messageBoxButton과 값은 같지만 DOM 순서상 칩이 뒤에 있어 칩이 위로 그려진다.
   */
  hintChip: 102,
  freeBadge: 101,
  /* NOTE: 모바일 페이지 이동 및 다운로드 등 버튼 z-index */
  mobileLayer: 30,
  /* NOTE: Desktop 페이지 이동 및 다운로드 등 버튼 z-index */
  desktopLayer: 104,
  ctaFormDimmer: 103,
  ctaFormLayer: 104,
  /* messageBox z-index */
  messageBox: 9999,
};
